
const IDENTITIES_TOOLTIPS = {
  className: <>Name to be used with &quot;setIdentity&quot; command.</>,
  name: <>Name of the unit.</>,
  speaker: <>Voice of the unit.</>,
  pitch: <>Voice pitch.</>,
  glasses: <>Accessory of the unit.</>,
  face: <>Face of the unit.</>
};

export default IDENTITIES_TOOLTIPS;